export const dataTableTheme = {
  header: {
    borderWidth: '1px 0 1px var(--reset)',
  },
  columnTitle: {
    fontWeight: '500',
  },
  bodyCell: {
    padding: 'var(--half-rem) var(--half-rem)',
  },
  footer: {
    padding: 'var(--half-rem) var(--half-rem)',
  },
  filter: {
    overlayPopover: {
      shadow: 'var(--overlay-box-shadow)',
      borderRadius: 'var(--border-radius)',
    },
  },
  colorScheme: {
    light: {
      header: {
        color: 'var(--text-color)',
        borderColor: 'var(--transparent)',
      },
      headerCell: {
        padding: 'var(--half-rem) var(--half-rem)',
        background: 'var(--p-surface-100)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-500)',
        selectedBackground: 'var(--p-surface-200)',
      },
      row: {
        color: 'var(--text-color)',
      },
      footerCell: {
        background: 'var(--p-surface-100)',
        color: 'var(--text-color)',
      },
      footer: {
        background: 'var(--p-surface-100)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-500)',
      },
    },
    dark: {
      header: {
        color: 'var(--text-color)',
        borderColor: 'var(--transparent)',
      },
      headerCell: {
        padding: 'var(--half-rem) var(--half-rem)',
        background: 'var(--p-surface-700)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-900)',
        selectedBackground: 'var(--p-surface-600)',
      },
      row: {
        color: 'var(--text-color)',
      },
      footerCell: {
        background: 'var(--p-surface-700)',
        color: 'var(--text-color)',
      },
      footer: {
        background: 'var(--p-surface-700)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-900)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-datatable .p-datatable-thead > tr > th.delete {
    color: var(--p-surface-500) !important;
  }

  /* Override reason: Prevents the frozen column from having a background color to follow design system */
  .p-datatable-scrollable td.p-datatable-frozen-column {
    background-color: transparent;
  }
  `,
};
